module.exports = __webpack_public_path__ + "static/media/christian.56633ed3.jpg";